import React from 'react';

const flightNote = (props) => (
    <div className="p-2 u-boxShadowNormal u-borderRadius4">
        <p className="u-fontSize11"><span className="u-fontWeightMedium u-textColorDark">Note:</span> <span className="u-textColorNormal">{props.children}</span></p>
    </div>
)

export default flightNote;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightNote/FlightNote.js